exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.responsive-size[data-v-70b3a3da]{font-size:1.7rem}@media (min-width:768px){div.responsive-size[data-v-70b3a3da]{font-size:2.5rem;padding-bottom:20px!important}}", ""]);

// exports
